/*import logo from './logo.svg';
import './App.css'; */

/*
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}
  */

import { CarritoProvider } from "./context/CarritoContext";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Productos from './pages/Productos';
import ProductoDetalle from "./pages/ProductoDetalle";
import Carrito from "./pages/Carrito";
import Checkout from "./pages/Checkout";
import ContactoFAQ from "./pages/ContactoFAQ";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop"; // 👈 importar
import CookieBanner from "./components/CookieBanner";
import Privacidad from "./pages/Privacidad";
import Devolucion from "./pages/Devolucion";
import CartDrawer from "./components/CartDrawer";
import AddToCartBanner from "./components/AddToCartBanner";
import Pago from "./pages/Pago";


function App() {
  return (
    <CarritoProvider>
      <Router>
        <Navbar />

        {/* 👇 resetea el scroll al cambiar de ruta */}
        <ScrollToTop />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/productos" element={<Productos />} />
          <Route path="/producto/:id" element={<ProductoDetalle />} />
          <Route path="/carrito" element={<Carrito />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/contacto" element={<ContactoFAQ />} />
          <Route path="/privacidad" element={<Privacidad />} />
          <Route path="/devolucion" element={<Devolucion />} />
          <Route path="/pago" element={<Pago />} />
        </Routes>
        <CartDrawer />
        <AddToCartBanner />
        <Footer />
        <CookieBanner />
      </Router>
    </CarritoProvider>
  );
}

export default App;
